import type { StaticClientConfig } from "@/staticClientConfig";
import { getImgixImageURL } from "./getImgixImageURL";

export function convertImageSrcToImgixInText(
  text = "",
  imgixConfig: StaticClientConfig["imgix"],
  params = "",
) {
  return text.replace(
    /<img([^>]*?)src=(['"])(\/caas\/content\/api\/v1\/admin\/files)([^'"]*?)(['"])([^>]*?)>/gi,
    (match, beforeSrc, openQuote, apiPath, imageName, closeQuote, afterSrc) => {
      const path = `/uploads${imageName}`;
      const src = getImgixImageURL(path, imgixConfig, params);

      return `<img${beforeSrc}src=${openQuote}${src}${closeQuote}${afterSrc}>`;
    },
  );
}
